export const MAX_MESSAGE_LENGTH = 1000;
export const MAX_CHAT_HISTORY_LENGTH = 50;
